import { render, staticRenderFns } from "./UsersTableAccount.vue?vue&type=template&id=7cfb4820&scoped=true&"
import script from "./UsersTableAccount.vue?vue&type=script&lang=js&"
export * from "./UsersTableAccount.vue?vue&type=script&lang=js&"
import style0 from "./UsersTableAccount.vue?vue&type=style&index=0&id=7cfb4820&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfb4820",
  null
  
)

export default component.exports